import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import PricingCards from "../components/subscription/PricingCards";
import CmsEditBanner from "../helpers/cms/CmsEditBanner";
import { cmsConstructor } from "../helpers/cms/cmsConstructor";
import { useCmsHook } from "../helpers/cms/cmsHook";

import { fetchStatus } from "../store/slice/preferenceSlice";

function SubscriptionWindow() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { cmsInstance, setCmsInstance } = useCmsHook();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.location.pathname === "/subscription") {
      const fetchCmsInstance = async () => {
        const cmsObj = await cmsConstructor();
        setCmsInstance(cmsObj);
      };
      fetchCmsInstance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const account = searchParams.get("account");
    if (account) {
      dispatch(fetchStatus(account));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page-bg-container">
      {window.location.pathname === "/subscription" && (
        <div className="d-flex flex-row justify-content-center">
          <CmsEditBanner />
        </div>
      )}
      <div className="page-bg-container d-flex flex-column justify-content-center align-items-center">
        <Row className="d-flex flex-row justify-content-center align-items-center h-100 w-100 px-2 mt-5">
          <Col sm={10} md={8} lg={5} className="px-0">
            {cmsInstance &&
              cmsInstance.showRichText(
                "cmsContent.subscription.description",
                "subscription-window"
              )}
            <PricingCards />
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default SubscriptionWindow;
